import {Map} from 'immutable';
import {Video} from '@albert-io/atomic';

export default Map({
  renderer: Video,
  hidden: true,
  type: 'video',
  label: 'Video'
});
